export const SEARCH_BOX_OPEN = "SEARCH_BOX_OPEN";
export const SEARCH_BOX_CLOSE = "SEARCH_BOX_CLOSE";
export const MAIN_MENU_OPEN = "MAIN_MENU_OPEN";
export const MAIN_MENU_CLOSE = "MAIN_MENU_CLOSE";